<template>
  <b-badge :variant="statusVariant" class="eoc-status text-white">
    {{ statusText }}
  </b-badge>
</template>

<script>
export default {
  name: "EocStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
      validator: function(value) {
        return ["Pending", "Active", "Inactive"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    statusVariant() {
      switch (this.status) {
        case "Pending":
          return "warning";
        case "Active":
          return "success";
        case "Inactive":
          return "danger";
        default:
          return "";
      }
    },
    statusText() {
      switch (this.status) {
        case "Pending":
          return "PENDING";
        case "Active":
          return "ACTIVE";
        case "Inactive":
          return "INACTIVE";
        default:
          return "";
      }
    }
  }
};
</script>

<style></style>
